/**
 * @generated SignedSource<<301e1aea9c173c09e83b4e48877cd9e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "User__UpdateLocalePayload",
    "kind": "LinkedField",
    "name": "userUpdateLocale",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dbId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "locale",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserUpdateLocaleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserUpdateLocaleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "241ee763b4f2db51aacdf0b3460d1a58",
    "id": null,
    "metadata": {},
    "name": "UserUpdateLocaleMutation",
    "operationKind": "mutation",
    "text": "mutation UserUpdateLocaleMutation(\n  $input: User__UpdateLocaleInput!\n) {\n  userUpdateLocale(input: $input) {\n    user {\n      id\n      dbId\n      locale\n    }\n  }\n}\n"
  }
};
})();

node.hash = "6d3bae95e777cb63ecd32787391c0858";

module.exports = node;
